<template>
  <v-footer height="auto" dark>
    <div class="footer-container teal darken-2">
      <div>
        <a href="https://www.facebook.com/Siberian-Larch-1109601115809052/" target="_blank">
          <svg style="width:30px;height:30px" viewBox="0 0 24 24">
            <path fill="#FFF" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" />
          </svg>
        </a>
        <a href="https://www.instagram.com/siberianlarch_nz" target="_blank">
          <svg style="width:30px;height:30px" viewBox="0 0 24 24">
            <path fill="#FFF" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
          </svg>
        </a>
      </div>
      <div class="links-section">

        <div class="link-item">
          <v-btn
            color="white"
            flat
            class="caption"
            to="/privacy"
            :ripple="false"
          >
            Privacy Policy
          </v-btn>
        </div>


        <div class="link-item">
          <v-btn
            color="white"
            flat
            class="caption"
            to="/terms"
            :ripple="false"
          >
            Terms of service
          </v-btn>
        </div>

        <div class="link-item">
          <v-btn
            color="white"
            flat
            class="caption"
            to="/contact"
            :ripple="false"
          >
            Contact Us
          </v-btn>
        </div>

      </div>
      <div style="padding-top: 8px;" class="body-1">
        Copyright &copy;2018 — <strong>siberianlarchwood.co.nz</strong>, All rights reserved.
      </div>
    </div>
  </v-footer>
</template>

<script>
  import VFooter from 'vuetify/es5/components/VFooter'
  import VBtn from 'vuetify/es5/components/VBtn'
  export default {
    data () {
      return {
      }
    },
    components: {
      VFooter,
      VBtn
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*styles for smaller screens*/

  .footer-container {
    width: 100vw;
    min-height: 90px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 32px;
    padding-bottom: 8px;
  }

  .pod--justify-space-around {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .links-section {
    width: 100%;
    display: flex;
  }

  .link-item {
    width: 33%;
  }

  @media (max-width: 767px) {
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?6d97d5e1